/**
 * phase-forms-workflow-follow-up (Item C) — shared types + helper for editing a
 * submission requirement. Kept out of the component file so fast-refresh only
 * sees component exports there.
 */
export type RequirementCatalog = 'form' | 'template';
export type StatusLevel = 'required' | 'conditional' | 'optional';

export interface EditableRequirement {
  catalog: RequirementCatalog;
  /** The resolved winner row id (built-in id, or the override's id). */
  id: string;
  /** True for a built-in (TenantId null) OR an existing override. */
  isBuiltInOrOverride: boolean;
  /** The built-in this override/edit targets (id itself for a plain built-in). */
  baselineId: string;
  name: string;
  status: StatusLevel;
  conditional: string | null;
  notes: string | null;
  activityCode: string | null;
  /** Context (read-only). */
  contextLabel: string;
}

export function statusOf(required: boolean, conditional: string | null): StatusLevel {
  if (required) return 'required';
  if (conditional && conditional.trim() !== '') return 'conditional';
  return 'optional';
}
